// extracted by css-extract-rspack-plugin
export default {"root":"root-WL2e7n","static":"static-gqnL7A"};